__turbopack_context__.v({
  "Container": "QuestionnaireNextSectionHeader-module__SivHLG__Container",
  "FixedContainer": "QuestionnaireNextSectionHeader-module__SivHLG__FixedContainer",
});
